import Widget, { registerModuleClass } from '@sparta.global.utilities/sparta-widget-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { startsWith } from '@sparta.global.helpers/strings-helper/dist/es6.js';

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"head-row","==",(depth0 != null ? lookupProperty(depth0,"position") : depth0),{"name":"compare","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":2},"end":{"line":13,"column":14}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "			<section id=\"head-row\" class=\"small-centered head-row\" "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"data-magellan-fixed") : stack1),"==","true",{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":58},"end":{"line":4,"column":158}}})) != null ? stack1 : "")
    + ">        \n				<div class=\"row spa-collapse-small spa-uncollapse-large\">\n					<div class=\"large-12 column\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"module") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":6},"end":{"line":9,"column":15}}})) != null ? stack1 : "")
    + "					</div>\n				</div>\n			</section>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "data-magellan-expedition=\"fixed\"";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "							"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"renderedHTML") : depth0), depth0)) != null ? stack1 : "")
    + "\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"head-sub-row","==",(depth0 != null ? lookupProperty(depth0,"position") : depth0),{"name":"compare","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":2},"end":{"line":26,"column":14}}})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "			<section id=\"head-row\" class=\"small-centered head-row\" "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"data-magellan-fixed") : stack1),"==","true",{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":58},"end":{"line":17,"column":158}}})) != null ? stack1 : "")
    + ">\n				<div class=\"row spa-collapse-small spa-uncollapse-large\">\n					<div class=\"large-12 column\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"module") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":6},"end":{"line":22,"column":15}}})) != null ? stack1 : "")
    + "					</div>\n				</div>\n			</section>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"startsWith")||(depth0 && lookupProperty(depth0,"startsWith"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"dynamic-row",(depth0 != null ? lookupProperty(depth0,"position") : depth0),{"name":"startsWith","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":2},"end":{"line":39,"column":17}}})) != null ? stack1 : "");
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "		<section class=\"small-centered "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"sectionClass") : depth0), depth0))
    + " "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"options") : depth0)) != null ? lookupProperty(stack1,"sectionClass") : stack1), depth0))
    + "\" "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"data-magellan-fixed") : stack1),"==","true",{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":90},"end":{"line":30,"column":211}}})) != null ? stack1 : "")
    + ">\n			<div class=\"row spa-collapse-small spa-uncollapse-large\">\n				<div class=\"large-12 column\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"module") : depth0),{"name":"each","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":33,"column":5},"end":{"line":35,"column":14}}})) != null ? stack1 : "")
    + "				</div>\n			</div>\n		</section>\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-magellan-destination=\""
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"sectionClass") : depth0), depth0)) != null ? stack1 : "")
    + "\"";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "						"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"renderedHTML") : depth0), depth0)) != null ? stack1 : "")
    + "\n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"foot-row","==",(depth0 != null ? lookupProperty(depth0,"position") : depth0),{"name":"compare","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":42,"column":2},"end":{"line":52,"column":14}}})) != null ? stack1 : "");
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "		  <section class=\"small-centered foot-row\" >\n		    <div class=\"row spa-collapse-small spa-uncollapse-large\">\n		      <div class=\"large-12 column\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"module") : depth0),{"name":"each","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":46,"column":4},"end":{"line":48,"column":13}}})) != null ? stack1 : "")
    + "		      </div>\n		    </div>\n		  </section>\n";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "					"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"renderedHTML") : depth0), depth0)) != null ? stack1 : "")
    + "\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-component=\"layout\" data-layout=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"name") : stack1), depth0))
    + "\" data-version=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"layoutVersion") : stack1), depth0))
    + "\" class=\"sparta-layout layout-1col-multi-row\" id=\"top\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"sections") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":1},"end":{"line":14,"column":10}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"sections") : stack1),{"name":"each","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":1},"end":{"line":27,"column":10}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"sections") : stack1),{"name":"each","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":1},"end":{"line":40,"column":10}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"sections") : stack1),{"name":"each","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":41,"column":1},"end":{"line":53,"column":10}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  return Template$1(data, options);
};

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global.widgets/global-search-public-widget",
  "version": "2.0.0",
  "id": "globalSearchPublicWidget",
  "containerID": "globalSearchPublicWidget",
  "moduleName": "global-search-public-widget",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "global-search-public-widget",
  "data": {
    "init": "GlobalSearchPublicWidget"
  },
  "moduleParams": [],
  "layout": renderTemplate$1,
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        compare,
        startsWith
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    compare,
    startsWith
  },
  "dependencies": {
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/strings-helper": "^1.0.0",
    "@sparta.global-gt.modules/global-search-input-module": "^1.0.0",
    "@sparta.global-gt.modules/global-search-autocomplete-module": "^1.0.0",
    "@sparta.global-gt.modules/global-search-results-module": "^1.0.0",
    "@sparta.global.templates/abbr-template": "^1.0.0",
    "@sparta.global.templates/flex-grid-layout": "^1.0.0",
    "@sparta.global.templates/footnote-suplink": "^1.0.0",
    "@sparta.global.templates/glossary-link": "^1.0.0",
    "@sparta.global.templates/glossary-terms": "^1.0.0",
    "@sparta.global.templates/widget-layout-support-footer": "^1.0.0",
    "@sparta.global.templates/widget-layout-support-header": "^1.0.0",
    "@sparta.global.templates/link-template": "^1.0.0",
    "@sparta.global.templates/render-module-template": "^1.0.0",
    "@sparta.global.templates/sitemap-xml-template": "^1.0.0",
    "@sparta.global.utilities/sparta-widget-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-bootstrap-utility": "^1.0.0"
  }
};

/**
 * Widget global-search-public-widget
 * @description This widget is responsible for rendering Search UI and provides search, autocomplete and search results behavior in unauthenticated space.
 */

/**
 * This widget's unique identifier.
 * @type {string}
 */
const WIDGET_NAMESPACE = 'widget-global-search-public-widget';

/**
 * Stores widget events for this widget.
 * @type {object<string>}
 */
const WIDGET_EVENTS = {
  WIDGET_RESPONSE: `WIDGET_RESPONSE.${WIDGET_NAMESPACE}`,
  WIDGET_QUERY: `WIDGET_QUERY.${WIDGET_NAMESPACE}`,
  WIDGET_READY: `WIDGET_READY.${WIDGET_NAMESPACE}`
};

/**
 * The GlobalSearchPublicWidget.
 * This widget is responsible for rendering Search UI and provides search, autocomplete and search results behavior in unauthenticated space.
 * @export
 * @class
 */
class GlobalSearchPublicWidget extends Widget {
  /**
   * Creates an instance of GlobalSearchPublicWidget.
   * @param {object} options - used to initialize utility.
   * @memberof GlobalSearchPublicWidget
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.params = window.spaWidgetParams[this.name][this.version];
  }

  /**
   * Used to execute logic once widget is ready.
   * @returns {void}
   */
  widgetReady() {
    //Publish event to support unauth sales site small breakpoint use case
    try {
      super.widgetReady();
      const widget = document.querySelectorAll('[data-sparta-container="' + this.name + '"]')[0];
      const widgetOptionsStr = widget.getAttribute('data-sparta-options');
      const widgetOptionsObj = JSON.parse(widgetOptionsStr);
      const widgetReadyEvtArgs = {
        wInfo: this.settings.widgetInfo,
        wParams: widgetOptionsObj
      };
      this.widgetEvents.pub(WIDGET_EVENTS.WIDGET_READY, widgetReadyEvtArgs);
      this.applicationContainer.classList.add('global-search-widget-container');
    } catch (error) {
      console.log(error);
    }
  }
  refreshWidget(event) {
    this.spartaEvents.pub("EVENT_UTILITY_1.REFRESH", event); // To reset a module's state, dispatch a spartaEvent for its listener.
    this.emitWidgetReady(); // After refreshing, dispatch the widgetReady event again.
  }
}
registerModuleClass({
  moduleClass: GlobalSearchPublicWidget,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { GlobalSearchPublicWidget as default, moduleConfig };
